<template>
    <div class="swiper-slide">
        <slot></slot>
        <div v-if="parent.lazy" class="swiper-lazy-preloader"></div>
    </div>
</template>

<script>
export default {
    inject: ['parent'],
    name: 'Slide',

    mounted() {
        this.$slots.default.forEach(el => {
            if (el.elm.tagName == 'IMG') {
                el.elm.classList.add('swiper-lazy');
            }
        });
    },
};
</script>
